import Bricks from 'bricks.js';
import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import cookiePopup from "@/modules/popup-cookie";
import handleScroll from "@/modules/section-header";



const mediaTablet = '768px';
const mediaTabletLG = '900px';
const mediaDesktop = '1170px';
const mediaDesktopLG = '1200px';
const sizes = [
  { columns: 1, gutter: 28 },
  { mq: mediaTablet, columns: 2, gutter: 16 },
  { mq: mediaTabletLG, columns: 2, gutter: 24 },
  { mq: mediaDesktop, columns: 3, gutter: 16 },
  { mq: mediaDesktopLG, columns: 3, gutter: 24 }
];
const reviewsList = Bricks({
  container: '.customers-reviews-list',
  sizes,
  packed: 'packed'
});


ready( () => {
  reviewsList.pack().resize(true);
  initFooterSection();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});
